<template lang="pug">
#grid
  Header
    PhoneAndEmail
  Navbar
  .content
    transition(name="fade" mode="out-in")
      router-view
  Footer
    PhoneAndEmail
  RomatchModal(:show="showModal" :message="modalMessage" @hide="showModal = false")
</template>

<script>
import Navbar from './Navbar.vue'
import Footer from './Footer.vue'
import Header from './Header.vue'
import PhoneAndEmail from './PhoneAndEmail.vue'

export default {
  name: 'Layout',
  components: { Navbar, Footer, PhoneAndEmail, Header },
  data() {
    return {
      modalMessage: '',
      showModal: false,
    }
  },
  mounted() {
    this.$bus.$on('alert', message => {
      this.modalMessage = message
      this.showModal = true
    })
  },
}
</script>

<style lang="stylus">
@import '~@/assets/reset.css'
@import '~@/assets/_typography.styl'
@import '~@/assets/_variables.styl'
@import '~@/assets/_layout.styl'
@import '~@/assets/_forms.styl'

#grid
  text-align center
  display grid
  grid-template-columns repeat(6, 1fr)
  grid-template-rows auto auto 1fr auto
  height 100vh

.content
  grid-column 1 / -1
  background-color page-background-color

.fade-enter-active, .fade-leave-active
  transition opacity 0.2s ease

.fade-enter, .fade-leave-to
  opacity 0
</style>
